import React from 'react';
import { FC } from 'react';

enum EyeIconVariant {
  ACTIVE = '#344054',
  CLOSE = '#98A2B3',
}

type EyeIconProps = {
  iconColor?: string;
  variant?: keyof typeof EyeIconVariant;
} & React.SVGProps<SVGSVGElement>;

const EyeIcon: FC<EyeIconProps> = ({ variant = 'ACTIVE', iconColor, ...props }) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 14"
    width="24"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.42012 8.71318C1.28394 8.49754 1.21584 8.38972 1.17772 8.22342C1.14909 8.0985 1.14909 7.9015 1.17772 7.77658C1.21584 7.61028 1.28394 7.50246 1.42012 7.28682C2.54553 5.50484 5.8954 1 11.0004 1C16.1054 1 19.4553 5.50484 20.5807 7.28682C20.7169 7.50246 20.785 7.61028 20.8231 7.77658C20.8517 7.9015 20.8517 8.0985 20.8231 8.22342C20.785 8.38972 20.7169 8.49754 20.5807 8.71318C19.4553 10.4952 16.1054 15 11.0004 15C5.8954 15 2.54553 10.4952 1.42012 8.71318Z"
      stroke={iconColor ?? EyeIconVariant[variant]}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M11.0004 11C12.6573 11 14.0004 9.65685 14.0004 8C14.0004 6.34315 12.6573 5 11.0004 5C9.34355 5 8.0004 6.34315 8.0004 8C8.0004 9.65685 9.34355 11 11.0004 11Z"
      stroke={iconColor ?? EyeIconVariant[variant]}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
export default EyeIcon;
